import { useEffect, useState } from 'react';
import { useParams } from 'react-router';

import { QualityProgressionContext } from '@/contexts/QualityContext';
import { DETAIL_TYPE, useDetailMode } from '@/hooks/useDetailMode';
import { useQuality } from '@/hooks/useQualitiesAPI';
import PageLayout from '@/layouts/PageLayout';

import {
  QualityProgressionActionsHead,
  QualityProgressionActionsTail,
} from './QualityActions';
import QualityProgressionEffectivenessPanel from './QualityProgressionEffectivenessPanel';
import QualityProgressionPlanPanel from './QualityProgressionPlanPanel';

const DEFAULT_FORM = {
  actionPlansJustification: '',
  ecJustification: '',
  effectivenessSubmitted: false,
  planSubmitted: false,
};

const QualityProgressionPage = () => {
  const { id } = useParams();
  const [form, setForm] = useState(DEFAULT_FORM);

  const { mode } = useDetailMode(DETAIL_TYPE.QUALITY);
  const { quality } = useQuality(id);

  const setFormByKey = (key, value) => {
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  useEffect(() => {
    if (quality && !form.id) {
      setForm(() => ({ ...quality }));
    }
  }, [quality, form]);

  return (
    <QualityProgressionContext.Provider
      value={{
        form,
        id,
        mode,
        setFormByKey,
      }}
    >
      <PageLayout
        subtitle={`Event: ${quality?.informationDescription}`}
        title="Quality Event Progression"
        toolbarHead={<QualityProgressionActionsHead />}
        toolbarTail={<QualityProgressionActionsTail />}
      >
        <QualityProgressionPlanPanel />
        <QualityProgressionEffectivenessPanel />
      </PageLayout>
    </QualityProgressionContext.Provider>
  );
};

export default QualityProgressionPage;
